import type React from "react";
import { ButtonsList } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/ButtonsList";
import { i18nFilter } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { Step } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/Step";
import type { IStepMetadata } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import {
    EnumWizardItems,
    setActivationWizardItems,
} from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardApi";

export const TrackAndShareStep: React.FC<IStepMetadata> = (props) => {
    const i18n = i18nFilter();

    const createTemplateDashboard = (): void => {
        setActivationWizardItems(EnumWizardItems.IsCreateDashboardFromHP, true);
        props.onStepComplete("growth.homepage.wizard.button.dashboard");
        proNavigator.go("dashboard-gallery");
    };

    const createCustomDashboard = (): void => {
        props.onStepComplete("growth.homepage.wizard.button.dashboardMetric");
        proNavigator.go("dashboard-gallery-blank");
    };

    return (
        <Step
            {...props}
            title={i18n("growth.homepage.activationWizard.step.track_and_share.title")}
            description={i18n("growth.homepage.activationWizard.step.track_and_share.description")}
            buttonsList={
                <ButtonsList
                    buttons={[
                        {
                            text: i18n("growth.homepage.activationWizard.step.track_and_share.button.1"),
                            onClick: createTemplateDashboard,
                            type: "primary",
                        },
                        {
                            text: i18n("growth.homepage.activationWizard.step.track_and_share.button.2"),
                            onClick: createCustomDashboard,
                            type: "flat",
                        },
                    ]}
                />
            }
        />
    );
};
